module.exports = __webpack_public_path__ + "img/drop_blue.5338f3ce.png";